import type { OverlayItem } from "./overlayConfig";

// 边缘边距。0908 曾设 0.02(老板实测 logo 贴死右缘观感「超出」);1029 用户反馈「logo / 二维码
// 拖不到最上面或最下面,想紧贴边缘」→ 改 0:手动拖放可以贴边,只保证不出画布。
// 自动落角路(overlay_autoplace 的 padding)不受影响,默认位置照旧留呼吸位。
export const OVERLAY_EDGE_MARGIN = 0;

/**
 * 画布像素矩形 → 归一化 overlay bbox。
 *
 * V6 fix4 (2026-05-12):w/h 钳到 (1 - x)/(1 - y) 严格保证 x+w ≤ 1, y+h ≤ 1 —— 否则 ResizeObserver
 * 拿到的 canvasW/H 是 subpixel float,`Math.round(bbox*canvas)` 双向漂移使 x+w 略 > 1,撞后端
 * OverlayConfigValidator「超出下边界」。
 *
 * 边距 M:把 x/y 关进 [M, 1-M-尺寸],x+w / y+h ≤ 1-M;尺寸先夹到 (1-2M) 内,再据此定位。
 * 1029 起 M=0(用户要能贴边),这套夹取仍保证不出画布。
 *
 * ★放在 lib(而非 DragOverlayCanvas 组件文件)是为了能单测、且不触发 react-refresh/only-export-components。
 */
export function pxRectToBbox(
  pos: { x: number; y: number; width: number; height: number },
  canvasW: number,
  canvasH: number,
  existing: OverlayItem | null
): OverlayItem {
  const M = OVERLAY_EDGE_MARGIN;
  const w = Math.max(0, Math.min(1 - 2 * M, pos.width / canvasW));
  const h = Math.max(0, Math.min(1 - 2 * M, pos.height / canvasH));
  const x = Math.min(Math.max(pos.x / canvasW, M), 1 - M - w);
  const y = Math.min(Math.max(pos.y / canvasH, M), 1 - M - h);
  return {
    x,
    y,
    w,
    h,
    rotation: existing?.rotation,
  };
}
